import { EventEmitter, InjectionToken } from '@angular/core';

export interface UmssRadioItem {
  value: unknown;
  checked: boolean;
  disabled: boolean;
  name: string | undefined;
  checkedChange: EventEmitter<unknown>;
}

export const UMSS_RADIO_ITEM = new InjectionToken<UmssRadioItem>(
  'UmssRadioItem'
);
